import { render, staticRenderFns } from "./FormCourseAliasModal.vue?vue&type=template&id=61e47592&scoped=true&"
import script from "./FormCourseAliasModal.vue?vue&type=script&lang=js&"
export * from "./FormCourseAliasModal.vue?vue&type=script&lang=js&"
import style0 from "./FormCourseAliasModal.vue?vue&type=style&index=0&id=61e47592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e47592",
  null
  
)

export default component.exports